module.exports = __webpack_public_path__ + "img/6.bea08cfa.png";